<template>
  <div class="cte-veiculo-estrutura">
    <div class="cte-veiculo-estrutura-limites"></div>
    <div class="cte-veiculo-estrutura-chassi"></div>
    <div class="cte-veiculo-estrutura-chassi cte-veiculo-estrutura-chassi2">
    </div>
    <div v-for="(e, i) in value" :key="i" v-if="i !== 'estepe'"
      :class="`${i == 'E1' ? 'cte-veiculo-estrutura-eixo' : 'cte-veiculo-estrutura-eixo2'}`">
      <label
        class="cte-veiculo-estrutura-eixo-label">{{i != 'estepe' ? i : ''}}</label>
      <div v-if="temPneuNoEixo(e)" class="cte-veiculo-estrutura-risco"></div>
      <div v-for="(p, j) in e" :key="j"
        :class="`cte-veiculo-estrutura-${p.posicao} ${classPneu(p)}`"
        :title="`${i}_${p.posicao}`" @click='pneuClick(p)'>
        <span v-if="p.warning"
          style="position: absolute; display: inline-block; width: 10px;
                      height: 10px; background-color: red; top: 10px;z-index: 2;border-radius: 50%"></span>
        <s-cte-pneu :dragable="dragPneus" :value="modelar ? p.marcado : p.pneu"
          :dragdata="pneuDragdata" :dropcheck="pneuDropcheck"
          @pneudrop="(e) => {pneuDrop(e, i, p)}" />
      </div>
    </div>
    <div class="cte-veiculo-estrutura-limites"></div>
    <div v-if="value.estepe">
      <div v-for="(p, j) in value.estepe" :key="j"
        :class="`cte-veiculo-estrutura-${p.posicao} cte-veiculo-estrutura-estepe-bottom ${classPneu(p)}`"
        :title="`estepe_${p.posicao}`" @click='pneuClick(p)'>
        <span v-if="p.warning"
          style="position: absolute; display: inline-block; width: 10px;
                      height: 10px; background-color: red; top: 10px;z-index: 2;border-radius: 50%"></span>
        <s-cte-pneu :dragable="dragPneus" :value="modelar ? p.marcado : p.pneu"
          :dragdata="pneuDragdata" :dropcheck="pneuDropcheck"
          @pneudrop="(e) => {pneuDrop(e, 'estepe', p)}" />
      </div>
    </div>
  </div>
</template>

<script>
import rawCss from "!!css-loader!./style.css";

export default {
  name: "s-cte-veiculo-estrutura",

  inject: ["hdl"],

  props: {
    value: [Object, Array],
    modelar: {
      type: Boolean,
      default: false,
    },
    pneuDragdata: String,
    pneuDropcheck: Function,
  },

  computed: {
    dragPneus() {
      return !this.modelar;
    },
  },

  methods: {
    classPneu(p) {
      if (this.modelar) {
        return p.marcado ? "cte-veiculo-estrutura-pneu-bold" : "";
      }
      return p.marcado === false ? "cte-veiculo-estrutura-pneu-oculto" : "";
    },

    temPneuNoEixo(eixo) {
      if (this.modelar) {
        return true;
      }
      for (let i = 0; i < eixo.length; i++) {
        if (eixo[i].marcado) {
          return true;
        }
      }
      return false;
    },

    pneuClick(p) {
      if (this.modelar) {
        p.marcado = !p.marcado;
        return;
      }
      p.pneu && this.$emit("pneuclick", p.pneu);
    },

    pneuDrop(pneu, eixo, p) {
      this.$emit("pneudrop", {
        pneu: pneu,
        posicao: `${eixo}_${p.posicao}`,
      });
    },
    imprimir() {
      const cssText = rawCss.toString();
      const el = document.createElement("div");
      el.innerHTML = `<div>${this.hdl.$("veiculo").innerHTML}</div>`;
      const style = `${cssText}
      .cte-veiculo-estrutura { zoom: 1.9; }`;
      new Siggma.utils.Printd().print(el, [style]);
    },
  },
};
</script>

<style>
@import "./style.css";
</style>